import * as React from "react";
import classnames from "classnames";
import { H2 } from "@grandvisionhq/iris-ui";
import { useConfiguratorContext } from "../../../../Context/Context/ConfiguratorContext.js";
import { ConfiguratorHeaderProgress } from "./ConfiguratorHeaderProgress.js";
/* empty css                        */
const ConfiguratorHeader = ({
  className,
  currentStepIndex,
  currentSubStepIndex,
  stepNameLabels,
  subStepsPerStep,
  ...rest
}) => {
  const { isFooterOpen } = useConfiguratorContext();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("configurator-header", className, {
        "configurator-header--summary-expanded": isFooterOpen
      }),
      "data-t": rest["data-t"]
    },
    /* @__PURE__ */ React.createElement(H2, { variant: "heading-smallest", className: "configurator-header__heading" }, stepNameLabels[currentStepIndex]),
    /* @__PURE__ */ React.createElement(
      ConfiguratorHeaderProgress,
      {
        className: "configurator-header__progress",
        currentStepIndex,
        currentSubStepIndex,
        totalSteps: stepNameLabels.length,
        subStepsPerStep
      }
    )
  );
};
export {
  ConfiguratorHeader
};
//# sourceMappingURL=ConfiguratorHeader.js.map
